const state = {
  token: "",
  refreshToken: null,
  tokenType: 0,
  userLevel: 0,
  partnerId: "",
  isValid: false,
  userName: "",
  user: null,
  userGroups: null,
  userType: 'u',
  tmpPartnerAdmin: false
}

const mutations = {
  setUserType (state, userType) {
    state.userType = userType
  },

  setUserName (state, userName) {
    console.log('auth object setUserName', userName);
    state.userName = userName
  },

  setUserLevel (state, userLevel) {
    console.log(" auth object setUserLevel", userLevel);
    state.userLevel = userLevel
  },

  setPartnerId (state, partnerId) {
    console.log(" auth object setPartnerId", partnerId);
    state.partnerId = partnerId
  },

  setTmpPartnerAdmin (state, tmpPartnerAdmin) {
    state.tmpPartnerAdmin = tmpPartnerAdmin;
  },

  setTokenType (state, tokenType) {
    console.log('auth object setTokenType', tokenType);
    state.tokenType = tokenType
  },

  setRefreshToken (state, refreshToken) {
    console.log('auth object setRefreshToken', refreshToken);
    state.refreshToken = refreshToken
  },

  setToken (state, token) {
    // console.log('auth object setToken', token);
    state.token = token
    state.isValid = true

    // window.localStorage.setItem('auth', JSON.stringify(state))
  },

  setStore (state, { token, isValid }) {
    state.token = token
    state.isValid = isValid
  },

  setUser (state, user) {
    console.log('auth object setUser', user);
    state.user = user
  },

  logout (state) {
    state.token = ""
    state.isValid = false
    state.tokenType = 0
    state.userLevel = 0
    state.partnerId = ""
    state.userName = ""
    state.user = null
    state.userGroups = null
    state.userType = 'u'
    // window.localStorage.setItem('auth', JSON.stringify(state))
  },

  setUserGroups(state, userGroups) {
    state.userGroups = userGroups;
  }
}

const getters = {
  userType (state) {
    return state.userType
  },

  userName (state) {
    return state.userName
  },

  isValid (state) {
    return state.isValid
  },
  userLevel (state) {
    return state.userLevel
  },
  partnerId (state) {
    return state.partnerId
  },
  tmpPartnerAdmin (state) {
    return state.tmpPartnerAdmin;
  },
  tokenType (state) {
    return state.tokenType
  },

  user (state) {
    return state.user
  },

  token (state) {
    return state.token
  },

  refreshToken (state) {
    return state.refreshToken
  },

  userGroups (state) {
    return state.userGroups
  }
}

export const actions = {
  logout ({ commit }) {
    commit('logout')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
